import MockAdapter from 'axios-mock-adapter'
import axios from 'axios'
import db from "./db.json"

export default {
 
    bootstrap() {
 
        let mock = new MockAdapter(axios)
        
        const NUM = 6  // #example in db

        for (let i = 0; i < NUM; i++) {
            mock.onGet('/example',  { params: {textNo: i} }).reply(200, db[i]) // 200 为状态码，后面对象为返回data
        }

        mock.onPost('/predict').reply(200, { 

        })
    }
 
}